module.exports = __webpack_public_path__ + "img/home-insurance.23625fe.svg";